import { render, staticRenderFns } from "./FavoriteItems.vue?vue&type=template&id=6672e1de&scoped=true&"
import script from "./FavoriteItems.vue?vue&type=script&lang=js&"
export * from "./FavoriteItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6672e1de",
  null
  
)

export default component.exports